<template src="./fuel.html"></template>
<script>
import VueGallery from "vue-gallery";
import Multiselect from "vue-multiselect";
import Axios from "axios";
import $ from "jquery";
import { GChart } from "vue-google-charts";
import * as Chartist from "chartist";
import GetcurrencySymbol from "@/assets/js/currency_sign.js";
var moment = require("moment");
let FuelByVehicle = "";
export default {
  components: {
    VueGallery,
    Multiselect,
    GChart,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      currency_type : GetcurrencySymbol(),
      basic: {
        currentPage: 1,
        totalPages: 0,
      },
      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      ShowLoader: false,
      showLocationDetails: false,
      ShowDashboardDetailPopup: false,
      ShowAddDocument: false,
      TotalCost: 0,
      TotalMonthVolume: 0,
      TotalMonthCost: 0,
      TotalMonthAvgMpg: 0,
      LitresDocID: 0,
      LitresDocPopup: false,
      fuel_export_data: [],
      TotalMonthAvgPerVehicleCost: 0,
      document_id: 0,
      fromDate: "",
      toDate: "",
      file: "",
      StorageType: "",
      DataLoader: true,
      infoOpened: false,
      locationPoints: "",
      SelectAllVehicle: false,
      VehicleRows: "",
      MileageUnit: "Miles",
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },
      Records: [],
      TableData: [],
      FuelDates: [],
      Vehicles: [],
      FuelDetails: [],
      FuelByMileage: [],
      FuelByCost: [],
      FuelByMultipleVehicle: [],
      FuelByVehicle: [],
      DocumentModelFields: {},
      NewDocument: {},
      AssignDocument: {},
      FuleCardRec: {},
      FuelRecords: {
        recordType: 1,
        vehicles: [],
      },
      filter: {
        currentPage: 1,
        totalPages: 0,
      },
      filters: {
        keywords: {
          value: "",
          keys: ["volume", "reg", "driver", "cost", "mileage", "time", "date"],
        },
      },
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      FuelByVehicleSearch: {
        VehicleId: "0",
      },
      FuelListSearch: {
        fromDate: "",
        toDate: "",
        branch_id: "",
        vehicle_group: "",
        VehicleId: "0",
        keywords: "",
      },

      areaspalinechart: {
        series: [
          /*{
              name: 'series1',
              data: [31, 40, 28, 51, 42, 109, 100],
            },
            {
              name: 'series2',
              data: [11, 32, 45, 32, 34, 52, 41],
            },*/
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "area",
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
            events: {
              click: function (event, chartContext, config) {
                FuelByVehicle = config.dataPointIndex;
              },
            },
          },
          markers: {
            size: [3, 4],
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          colors: ["#7366ff", "#f73164"],
          xaxis: {
            type: "text",
            categories: [],
          },
        },
      },
      fuelmultiplechart: {
        series: [
          /*{
              name: 'series1',
              data: [31, 40, 28, 51, 42, 109, 100],
            },
            {
              name: 'series2',
              data: [11, 32, 45, 32, 34, 52, 41],
            },*/
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "area",
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
            events: {
              click: function (event, chartContext, config) {
                FuelByVehicle = config.dataPointIndex;
              },
            },
          },
          markers: {
            size: [3, 4],
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          colors: [
            "#7366ff",
            "#f73164",
            "#058FE9",
            "#EC110C",
            "#EC950C",
            "#2CEC0C",
          ],
          xaxis: {
            type: "text",
            categories: [],
          },
        },
      },
      
      ShowAssignDocument: false,
      DriverSearchKey: "",
      Drivers: [],
      driver: {
        ids: [],
      },
      AssignVehicleID:"",
      SelectAllDriver:false,
      Groups:[],
      Branches: {},
      ShowMergeDocument: false,      
      MergeDocuments: [],
      MergeDocumentsSelected:{} ,
    };
  },
  mounted() {
   
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions["Fuel Tracking"] ||
        !AccountPermissions["Fuel Tracking"]["enable"])
    ) {
      this.$router.push("/");
    }
    document.title = pbx_SiteTitle + " - Reports";
    this.GetVehiclesListForAssign();
    this.GetGroups();
    this.GetBranches();
    this.GetDriversList();
    
    //this.GetFuelDocuments();
    this.GetFuelReport();
    this.GetFuelByVehicle();
    this.GetFuelList();    
    
    var CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (CompanyData.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
  },

  methods: {
    SearchDriver() {
      this.GetDriversList("search");
    },
    GetDriversList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.searchkey = this.DriverSearchKey;
        this.ResetDriverArray();
      }
      Axios.post(Endpoints.Driver.List, obj).then((Response) => {
        if (Response.data.success) {
          this.Drivers = Response.data.drivers;
        }
      });
    },
    check(e) {
      if (e.target.checked) {
        this.SelectAllDriver = true;
        this.SelectDriver = true;
        this.driver.ids = [];
        this.Drivers.forEach((element) => {
          this.driver.ids.push(element.id);
        });
      } else {
        this.ResetDriverArray();
      }
    },
    ResetDriverArray() {
      this.SelectAllDriver = false;
      this.SelectDriver = false;
      this.driver.ids = [];
      return true;
    },
    select: function () {
      this.SelectAllDriver = false;
    },
    checkVehicle(e) {
      if (e.target.checked) {
        this.SelectAllVehicle = true;
        //this.SelectDriver = true;
        this.AssignDocument.fields["vehicle"]["value"] = [];
        this.Vehicles.forEach((element) => {
          this.AssignDocument.fields["vehicle"]["value"].push(element.id);
        });
      } else {
        this.ResetAssignVehicleArray();
      }
    },
    selectVehicle: function () {
      this.SelectAllVehicle = false;
    },
    ResetAssignVehicleArray() {
      this.SelectAllVehicle = false;
      this.AssignDocument.fields["vehicle"]["value"] = [];
      return true;
    },
    AcceptCorrectLitres(){
      this.$swal({
        title: "Are you sure You want to accept fuel card provider litres?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#514b71",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Yes, accept it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.LitresDocPopup = false;
          this.$swal({
            title: "Processing...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Dcoument.LitresUpdate, {
            token: localStorage.getItem("token"),
            document_id: this.LitresDocID,
            litres: this.FuleCardRec.csc_litres,
          }).then((Response) => {
            this.$swal.close();
            if (Response.data.success == true) {
              this.GetFuelList();
              this.$swal("Record Updated Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal("Error:" + Response.data.message, "", "error").then(
                () => {}
              );
            }
          });
        }
      });
    },
    TransactionAccept(document_id, vehicle_id, deriver_ids){
      this.AssignVehicleID = vehicle_id;
      this.driver.ids = deriver_ids;

      this.$swal({
        title: "Are you sure You want to accept this transaction?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#514b71",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Accept Transaction",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.document_id = document_id;
          if(this.AssignVehicleID > 0 && this.driver.ids.length > 0){
            this.acceptTransactionData('assigned');
          }else{
            this.getAssignVehicles();
            this.ShowAssignDocument= true;
            this.LitresDocPopup = false;
            this.$swal.close();
          }
        }
      });
    },

    getAssignVehicles(){
      Axios.post(Endpoints.Dcoument.Model, {
          token: localStorage.getItem("token"),
          category: "fuel",
          sub_category: "fuel",
        }).then((Response) => {
          this.PopupLoader = false;
          if (Response.data.success == true && Response.data.models[0]) {
            var model = Response.data.models[0];
            this.AssignDocument.title = model.title;
            this.AssignDocument.fields = JSON.parse(model.fields);
            this.DocumentModelFields = JSON.parse(model.fields);

            for (const index in this.DocumentModelFields) {
              if (index == "vehicle") {
                this.AssignDocument.fields["vehicle"]["value"] = [];
                this.DocumentModelFields["vehicle"]["value"] = [];
              }
            }
          }
        });
    },

    acceptTransactionData(type){
      this.$swal({
            title: "Processing...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
      Axios.post(Endpoints.Dcoument.TransactionAccept, {
            token: localStorage.getItem("token"),
            document_id: this.document_id,
            vehicle: this.AssignVehicleID,
            drivers: this.driver.ids,
            type: type,
          }).then((Response) => {
            this.$swal.close();
            if (Response.data.success == true) {
              this.GetFuelList();
              this.$swal("Transaction Accepted Successfully", "", "success").then(
                () => {}
              );
              
              this.driver.ids = [];
              this.AssignVehicleID = "";
              this.ShowAssignDocument= false;
            } else {
              this.$swal("Error:" + Response.data.message, "", "error").then(
                () => {}
              );
            }
          });
    },
    showUpdateLitres(docID){
      var obj = { token: localStorage.getItem("token"), docID:docID };
      Axios.post(Endpoints.Report.FuleCardLiters, obj).then((Response) => {
        if (Response.data.success) {
          this.FuleCardRec = Response.data.record;
        }
      });
      this.LitresDocID = docID;
      this.LitresDocPopup = true;
    },
    GetVehiclesListForAssign() {
      var obj = { token: localStorage.getItem("token") };
      Axios.post(Endpoints.Vehicle.List, obj).then((Response) => {
        if (Response.data.success) {
          this.Vehicles = Response.data.vehicles;
        }
      });
    },
    selectFuelByVehicle() {
      if (FuelByVehicle >= 0) {
        this.FuelDetails = [];
        this.ShowDashboardDetailPopup = true;
        var obj = {
          token: localStorage.getItem("token"),
          category: "fuel",
          sub_category: "fuel",
          VehicleId: this.FuelByVehicleSearch.VehicleId,
          from_date: "",
          to_date: "",
          date_month: this.Records[FuelByVehicle].date3,
        };
        Axios.post(Endpoints.Report.FuelList, obj).then((Response) => {
          if (Response.data.success) {
            this.FuelDetails = Response.data.recordsList;
          }
        });
      }
    },
    SearchByMultipleVehicle() {
      var obj = {
        token: localStorage.getItem("token"),
        search_type: this.FuelRecords.recordType,
        vehicle_ids: this.FuelRecords.vehicles,
      };
      Axios.post(Endpoints.Report.FuelByMultipleVehicle, obj).then(
        (Response) => {
          if (Response.data.success) {
            this.FuelByMultipleVehicle = {};
            var data = Response.data.services;
            if (data.length > 0) {
              var vehicleIds = Response.data.vehicleIds;
              this.FuelByMultipleVehicle = {};
              this.FuelByMultipleVehicle.series = [];
              vehicleIds.forEach((element, index) => {
                this.VehicleRows = {
                  name: element["vrm"],
                  data: [],
                };
                this.FuelByMultipleVehicle.series.push(this.VehicleRows);
              });
              data.forEach((element, index) => {
                element["vehicles"].forEach((element2, index2) => {
                  if (this.FuelRecords.recordType == 1) {
                    this.FuelByMultipleVehicle.series[index2]["data"].push(
                      +element2["volume"]
                    );
                  }
                  if (this.FuelRecords.recordType == 2) {
                    this.FuelByMultipleVehicle.series[index2]["data"].push(
                      +element2["mpg"]
                    );
                  }
                  if (this.FuelRecords.recordType == 3) {
                    this.FuelByMultipleVehicle.series[index2]["data"].push(
                      +element2["cost"]
                    );
                  }
                });
                this.fuelmultiplechart.chartOptions.xaxis.categories.push(
                  element["date3"]
                );
              });
              this.ShowMultipleVehiclePopup = false;
              //this.ResetVehicleArray();
            } else {
              this.$swal
                .fire("Error: No Record Found", "", "error")
                .then(() => {});
            }
          }
        }
      );
    },
    ShowLocationMap(fuelDetails) {
      this.showLocationDetails = true;
      const marker = {
        lat: parseFloat(fuelDetails.latitude),
        lng: parseFloat(fuelDetails.longitude),
      };
      //this.center = marker;
      this.locationPoints = marker;
      this.infoOpened = true;
      this.infoOptions.content =
        '<div id="mapcontent"><h1 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
        fuelDetails.reg +
        "</h1></div>";
    },
    DownloadDocument(file) {
      window.open(this.ImageEndpoint + file, "_blank");
    },
    GetFuelDocuments() {
      var obj = {
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
      };
      Axios.post(Endpoints.Report.FuelByVehicle, obj).then((Response) => {
        if (Response.data.success) {
          this.TableData = Response.data.recordsList;
          this.TotalCost = Response.data.totalCost;
          this.DataLoader = false;
        }
      });
    },    
    EditFuelDocument(document) {
      this.NewDocument = {};
      this.ShowAddDocument = true;
      $("#file").val(null);
      this.file = "";
      this.NewDocument.id = document.id;
      this.NewDocument.document_id = document.id;
      this.NewDocument.title = "Fuel";
      this.NewDocument.category = "fuel";
      this.NewDocument.sub_category = "fuel";
      this.NewDocument.editdocument = true;
      if (typeof document.fields === "object") {
        this.NewDocument.fields = document.fields;
        this.DocumentModelFields = document.fields;
      } else {
        this.NewDocument.fields = JSON.parse(document.fields);
        this.DocumentModelFields = JSON.parse(document.fields);
      }
      this.NewDocument.type = "fuel";
      for (const index in this.NewDocument.fields) {
        if (index == "mileage") {
          this.NewDocument.fields["mileage"]["required"] = true;
        }
      }
    },
    GetFuelReport() {
      var obj = {
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
        from_date: this.FuelListSearch.fromDate,
        to_date: this.FuelListSearch.toDate,
        branch_id: this.FuelListSearch.branch_id,
        vehicle_group: this.FuelListSearch.vehicle_group,
        VehicleId: this.FuelListSearch.VehicleId,        
        date_month: "",
      };
      Axios.post(Endpoints.Report.FuelReportGet, obj).then((Response) => {
        if (Response.data.success) {
          this.TotalMonthVolume = Response.data.totalMonthlyVolume;
          this.TotalMonthCost = Response.data.totalMonthlyCost;
          this.TotalMonthAvgMpg = Response.data.totalMonthlyAvgMpg;
          this.TotalMonthAvgPerVehicleCost = Response.data.avgPerVehicleCost;
        }
      });
    },
    GetFuelByVehicle(type = "") {
      var obj = {        
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
        from_date: this.FuelListSearch.fromDate,
        to_date: this.FuelListSearch.toDate,
        branch_id: this.FuelListSearch.branch_id,
        vehicle_group: this.FuelListSearch.vehicle_group,
        VehicleId: this.FuelListSearch.VehicleId,        
        date_month: "",
      };
      if (type == "search") {
        obj.VehicleId = this.FuelByVehicleSearch.VehicleId;
      }
      Axios.post(Endpoints.Report.FuelByVehicle, obj).then((Response) => {
        this.DataLoader = false;
        if (Response.data.success) {
          this.Records = Response.data.services;

          this.FuelByVehicle = {};
          this.FuelByMileage = {};
          this.FuelByCost = {};
          var data = Response.data.services;

          //if (data.length > 1) {
          this.FuelByVehicle = {};
          this.FuelByVehicle.series = [
            { name: "Useage By Month", data: [] },
            { name: "Total Overall Useage", data: [] },
          ];
          this.FuelByMileage = {};
          this.FuelByMileage.series = [
            { name: "MPG By Month", data: [] },
            /*{ name: "Average MPG", data: [] },*/
          ];
          this.FuelByCost = {};
          this.FuelByCost.series = [
            { name: "Spend By Month ("+this.currency_type+")", data: [] },
            { name: "Total Overall Spend ("+this.currency_type+")", data: [] },
          ];

          this.FuelDates = [];

          data.forEach((element, index) => {
            this.FuelByVehicle.series[0]["data"].push(+element["volume"]);
            this.FuelByVehicle.series[1]["data"].push(+element["total_volume"]);

            this.FuelByMileage.series[0]["data"].push(+element["mgp"]);
            //this.FuelByMileage.series[1]["data"].push(+element["avg_mgp"]);

            this.FuelByCost.series[0]["data"].push(+element["cost"]);
            this.FuelByCost.series[1]["data"].push(+element["total_cost"]);

            this.areaspalinechart.chartOptions.xaxis.categories.push(
              element["date3"]
            );

            this.FuelDates.push(element["date3"]);
          });

          //Update xaxis data
          this.areaspalinechart.chartOptions = {
            chart: {
              height: 350,
              type: "area",
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
              events: {
                click: function (event, chartContext, config) {
                  FuelByVehicle = config.dataPointIndex;
                },
              },
            },
            markers: {
              size: [3, 4],
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
            },
            colors: ["#7366ff", "#f73164"],
            xaxis: {
              categories: this.FuelDates,
            },
          };

          //}
        }
      });
    },
    GetFuelList() {        
      var obj = {
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
        from_date: this.FuelListSearch.fromDate,
        to_date: this.FuelListSearch.toDate,
        branch_id: this.FuelListSearch.branch_id,
        vehicle_group: this.FuelListSearch.vehicle_group,
        VehicleId: this.FuelListSearch.VehicleId,        
        date_month: "",
      };
      Axios.post(Endpoints.Report.FuelList, obj).then((Response) => {
        if (Response.data.success) {
          this.TableData = Response.data.recordsList;
          this.TotalCost = Response.data.totalCost;
          this.fromDate = Response.data.start_date;
          this.toDate = Response.data.end_date;
          this.FuelListSearch.fromDate = Response.data.start_date;
          this.FuelListSearch.toDate = Response.data.end_date;

          this.fuel_export_data = [];
          if (this.TableData.length > 0) {
            this.TableData.forEach((element) => {
              var obj = {};
              obj["Date"] = element.date;
              obj["Vehicle"] = element.reg;
              obj["Driver"] = element.driver;
              obj["Litres"] = element.volume;
              obj["Price (Exc VAT)"] = this.currency_type + element.price_ex_vat;
              obj["PPL (Exc VAT)"] = this.currency_type + element.cost_per_litre_ex_vat;
              obj[this.MileageUnit] = element.mileage;
              obj["Card Number"] = element.card_number;
              this.fuel_export_data.push(obj);
            });
          }
        }
      });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.StorageType = "CFR";
    },
    UploadFile() {
      $("#fileUploadBtn").html("Uploading...");
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("storage_type", this.StorageType);
      formData.append("file", this.file);
      Axios.post(Endpoints.File.Upload, formData).then((Response) => {
        if (Response.data.success == true) {
          $("#fileUploadBtn").html("Upload");
          this.NewDocument.files = Response.data.file;
          this.NewDocument.filename = this.file.name;
          this.$swal("File Uploaded Successfully", "", "success").then(
            () => {}
          );
        } else {
          this.$swal("Error in File Uploading", "", "error").then(() => {});
        }
      });
    },
    AddDocumentSubmit() {
      var error = false;
      var errorStr = "";
      if (
        this.NewDocument.sub_category == "-1" &&
        this.NewDocument.new_sub_category_name == ""
      ) {
        error = true;
        errorStr += "<li>Please Enter Document Type</li>";
      }
      if (this.NewDocument.fields) {
        for (const [key, ele] of Object.entries(this.NewDocument.fields)) {
          if (
            key != "latitude" &&
            key != "longitude" &&
            ele.title != "Total Cost (Inc Vat)"
          ) {
            if (ele.required && (!ele.value || ele.value == "")) {
              error = true;
              errorStr += "<li>Please Enter " + ele.title + "</li>";
            }
            if (key == "mileage" && ele.value <= 0) {
              error = true;
              errorStr += "<li>Mileage should be greator then 0</li>";
            }
          }
        }
      }
      if (error == true) {
        this.$swal("Following Error Found!", errorStr, "error").then(() => {});
      } else {
        if (this.NewDocument.sub_category == "-1") {
          this.NewDocument.title =
            this.NewDocument.category +
            " " +
            this.NewDocument.new_sub_category_name;
          this.NewDocument.sub_category =
            this.NewDocument.new_sub_category_name;
          this.NewDocument.add_new_sub_category = 1;
        }
        this.$swal({
          title: "Adding Document...",
          text: "Please wait...",
          imageUrl: require("@/assets/images/LoadingTwo.gif"),
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        this.NewDocument.token = localStorage.getItem("token");
        (this.NewDocument.driver_ids = []),
          Axios.post(Endpoints.Dcoument.Create, this.NewDocument).then(
            (Response) => {
              if (Response.data.success == true) {
                this.ShowAddDocument = false;
                this.GetFuelList();
                this.$swal(
                  "Fuel Document Updated Successfully",
                  "",
                  "success"
                ).then(() => {});
              } else {
                this.$swal(Response.data.message, "", "error").then(() => {});
              }
            }
          );
      }
    },    
    SearchVehicle(type = null) {
      /*if (type == "make") {
        this.SearchData.model = "";
        if (this.SearchData.make == "") {
          this.Models = [];
        }
      }

      this.Vehicles = [];
      this.ActivityPage = 1;
      this.LastPageRequest = 0;
      this.GetVehiclesList("search");*/
    },
    GetGroups() {
      var obj = {token: localStorage.getItem("token")};
      Axios.post(Endpoints.Groups.List, obj).then((Response) => {
        //this.ShowLoader = false;
        if (Response.data.success) {
          this.Groups = Response.data.records;
        }
      });
    },
    GetBranches() {
      var obj = { token: localStorage.getItem("token"), select_branch: true };
      Axios.post(Endpoints.Branch.List, obj).then((Response) => {
        if (Response.data.success) {
          this.Branches = Response.data.records;
        }
      });
    },
    mergeFuelData() { 
    	this.MergeDocumentsSelected={}   	
    	
    	var selData = this.TableData.filter(function (user) {
            if (user.checked == true) return user;
        }); 
        if(selData.length<2){
        	this.$swal({
		        title: "Please selected atleast 2 document!",
		        text: "",
		        icon: "warning",		        		        
		        cancelButtonColor: "#aaa",
      		})
      		return true;
        }else if(selData.length>2){
        	this.$swal({
		        title: "You can only merge 2 document, So please select only 2 documents!",
		        text: "",
		        icon: "warning",		        		        
		        cancelButtonColor: "#aaa",
      		})
      		return true;
        }       
        selData.forEach((element,index) => {
            if(typeof selData[index]['fields'] == 'string'){	
          	 selData[index]['fields'] = JSON.parse(element.fields)
            }	
                    	
          	Object.keys(selData[index]['fields']).forEach(key => {                 				
                if(element.export_type==1){
          		    this.MergeDocumentsSelected[key]=index
                }                   
			});          
        });

        selData.forEach((element,index) => {
            Object.keys(selData[index]['fields']).forEach(key => {                              
                if(element.export_type==2 && (key=='date' || key=='volume' || key=='card_number'|| key=='price_ex_vat' )){
                    this.MergeDocumentsSelected[key]=index
                }                   
            });          
        });        
        

        if(selData[0]['fields']['card_number']['value'] != selData[1]['fields']['card_number']['value'] ||
           selData[0]['fields']['volume']['value'] != selData[1]['fields']['volume']['value'] ||
           moment(selData[0]['fields']['date']['value']).format("DD-MM-YYYY") != moment(selData[1]['fields']['date']['value']).format("DD-MM-YYYY")
        ){
        	this.$swal({
		        title: "You can't merge document because date, litres and fuel card are not same!",
		        text: "",
		        icon: "error",		        		        
		        cancelButtonColor: "#aaa",
      		})
      		return true;
        }

        console.log(selData)
      	this.MergeDocuments = selData
      	this.ShowMergeDocument = true
    },
    submitMergeFuelData(){
    	this.$swal({
            title: "Processing...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
        });    	    	
    	var obj = {
    		token: localStorage.getItem("token"),
    		MergeDocuments: this.MergeDocuments,
    		MergeDocumentsSelected: this.MergeDocumentsSelected,
    	};
      	Axios.post(Endpoints.Dcoument.FuelDataMerge, obj).then((Response) => {        	
        	if (Response.data.success) {
          		this.$swal.close();
          		this.ShowMergeDocument=false
	            if (Response.data.success == true) {
	              this.GetFuelList();
	              this.$swal("Record Updated Successfully", "", "success").then(
	                () => {}
	              );
	            } else {
	              this.$swal("Error:" + Response.data.message, "", "error").then(
	                () => {}
	              );
	            }
        	}
      	});
    }
  },
};
</script>

<style type="text/css">
.custom-scrollbar thead th.heading-padding-left {
  padding-left: 0.75rem !important;
}
g {
  cursor: pointer;
}
.margin-auto {
  margin: 0 auto;
}
.vehicle-details-modal {
  width: 100%;
}
.margin-right-auto {
  margin-right: auto !important;
}
.detail-link {
  color: #000;
}
.detail-link:hover {
  color: #000;
}
.filter-input-width {
  width: 20% !important;
}
#showOwnerDetails .modal-header {
  border-bottom: 0px !important;
}
#showOwnerDetails .modal-title {
  font-size: 14px !important;
}
.modal-table .table th,
.table td {
  padding: 0.75rem !important;
}
.vehicle-info-modal,
.owner-info-modal {
  padding-top: 0px !important;
}
#showVehicleDetails .modal-header {
  border-bottom: 0px !important;
}
#showVehicleDetails .modal-title {
  font-size: 14px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.map-modal-body {
  max-width: 1200px !important;
}
.page-link {
  line-height: 1.5 !important;
  height: 36px !important;
}
.card .report-icon {
  width: 83px;
}
.card .report-icon .report-icon-inner {
  border: 2px solid #8f4f88;
  height: 100%;
  width: 52px;
  text-align: center;
  margin-left: 6px;
  border-radius: 29px;
  padding: 11px;
  font-size: 17px;
  color: #8f4f88;
}
.card .report-number {
  width: 70%;
}
.card .report-average {
  margin-top: 25px;
}
.card .report-average span {
  color: rgb(143, 79, 136);
  font-size: 16px;
  font-weight: 400;
}
.report-box {
  background-image: url("../../assets/images/widget-bg.1e03d67b.png");
  background-position: right;
  overflow: hidden;
  background-repeat: no-repeat;
  border-radius: 10px;
}
.multiselect__tag {
  color: #fff !important;
  display: inline-block !important;
}
.multiselect__tag span {
  color: #fff !important;
}
.multiple-report {
  min-height: 529px;
}
</style>
